import { useEffect, useState, forwardRef, useImperativeHandle } from "react";

const EmailInputGroup = forwardRef((props, ref) => {
  const [emails, setEmails] = useState([]);
  const [input, setInput] = useState("");
  const [error, setError] = useState("");

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const getFinalEmails = () => {
    let finalEmails = [...emails];
    const value = input.trim();

    if (value) {
      if (!emailRegex.test(value)) {
        setError("Please enter a valid email address");
        return null;
      }

      if (!finalEmails.includes(value)) {
        finalEmails.push(value);
      }
    }

    return finalEmails;
  };

  // 👇 expose to parent
  useImperativeHandle(ref, () => ({
    getFinalEmails,
    reset: () => {
      setEmails([]);
      setInput("");
      setError("");
    },
  }));

  const addEmail = () => {
    const value = input.trim();

    if (!value) return;

    if (!emailRegex.test(value)) {
      setError("Please enter a valid email address");
      return;
    }

    if (emails.includes(value)) {
      setError("Email already added");
      return;
    }

    setEmails([...emails, value]);
    setInput("");
    setError("");
  };

  const removeEmail = (index) => {
    setEmails(emails.filter((_, i) => i !== index));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addEmail();
    }
  };

  return (
    <div>
      <div className="d-flex gap-2 mb-2">
        <input
          type="email"
          className="form-control"
          placeholder="Enter email"
          value={input}
          onChange={(e) => {
            setInput(e.target.value);
            setError("");
          }}
          onKeyDown={handleKeyDown}
        />

        <button className="btn btn-success" onClick={addEmail}>
          +
        </button>
      </div>

      {error && <small className="text-danger">{error}</small>}

      <div className="d-flex flex-wrap gap-2 mt-2">
        {emails.map((email, index) => (
          <span key={index} className="badge bg-light text-dark p-2">
            {email}
            <span
              style={{ cursor: "pointer", marginLeft: "8px" }}
              onClick={() => removeEmail(index)}
            >
              ✕
            </span>
          </span>
        ))}
      </div>
    </div>
  );
});

export default EmailInputGroup;